import type { LocalDate } from "@js-joda/core";
import { useTranslation } from "react-i18next";

import { DatePicker } from "components/designV2/datePicker/datePicker";
import { getIntroductoryEmploymentPeriodDeviation } from "./staffEmploymentRules.logic";
import {
  EmploymentPeriodField,
  EmploymentPeriodWarning,
} from "./staffEmploymentEndDateField.styled";

interface StaffEmploymentEndDateFieldProps {
  readonly allowClear: boolean;
  readonly disabled?: boolean;
  readonly employmentType?: string;
  readonly endDate: LocalDate | null;
  readonly label: string;
  readonly startDate: LocalDate | null;
  readonly onChange: (endDate: LocalDate | null) => void;
}

export const StaffEmploymentEndDateField = (
  props: StaffEmploymentEndDateFieldProps,
): JSX.Element => {
  const { t } = useTranslation();
  const deviation = getIntroductoryEmploymentPeriodDeviation({
    employmentType: props.employmentType,
    endDate: props.endDate,
    startDate: props.startDate,
  });
  const warningKey =
    deviation === "shorter"
      ? "Staff.introductoryPeriodShorterWarning"
      : "Staff.introductoryPeriodLongerWarning";

  return (
    <EmploymentPeriodField>
      <DatePicker
        label={props.label}
        value={props.endDate}
        disabled={props.disabled}
        onChange={props.onChange}
        allowClear={props.allowClear}
      />
      {deviation != null && (
        <EmploymentPeriodWarning role="status">
          {t(warningKey)}
        </EmploymentPeriodWarning>
      )}
    </EmploymentPeriodField>
  );
};
